const STORAGE_KEY = 'nudge.pendingReferralCode';
const UTM_STORAGE_KEY = 'nudge.pendingAttribution';

export function normalizeReferralCode(value = '') {
  return String(value || '').trim().toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 24);
}

export function getStoredReferralCode() {
  try { return normalizeReferralCode(localStorage.getItem(STORAGE_KEY) || ''); } catch { return ''; }
}

export function clearStoredReferralCode() {
  try { localStorage.removeItem(STORAGE_KEY); } catch { /* no-op */ }
}

export function captureReferralFromUrl(url = window.location.href) {
  try {
    const parsed = new URL(url);
    const params = parsed.searchParams;
    const code = normalizeReferralCode(
      params.get('ref') ||
      params.get('referral') ||
      params.get('invite') ||
      params.get('code') ||
      ''
    );
    const attribution = {
      ref: code,
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || '',
      landingPath: parsed.pathname || '/',
      capturedAt: new Date().toISOString(),
    };
    if (code) localStorage.setItem(STORAGE_KEY, code);
    if (attribution.utm_source || attribution.utm_campaign || code) {
      localStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(attribution));
    }
    return { code, attribution };
  } catch {
    return { code: '', attribution: null };
  }
}

function getPublicReferralBaseUrl() {
  const configured = import.meta.env?.VITE_REACT_APP_PUBLIC_SITE_URL || import.meta.env?.VITE_PUBLIC_SITE_URL || '';
  return configured || 'https://nudgeforme.com/';
}

export function buildReferralLink(code = '', { region = '', baseUrl = '' } = {}) {
  const clean = normalizeReferralCode(code);
  if (!clean) return '';
  const url = new URL(baseUrl || getPublicReferralBaseUrl());
  url.searchParams.set('ref', clean);
  // Referral links intentionally point to the public website first.
  // The website should keep the ref param and pass it to the app login/signup CTA.
  // Region stays an app choice, so we do not add a region param to public share links by default.
  if (baseUrl && region) url.searchParams.set('region', region);
  url.searchParams.set('utm_source', 'referral');
  url.searchParams.set('utm_medium', 'share');
  url.searchParams.set('utm_campaign', 'nudge_early_access');
  return url.toString();
}

export function socialShareLinks({ url = '', text = '' } = {}) {
  const encodedUrl = encodeURIComponent(url);
  const encodedText = encodeURIComponent(text || 'NudgeForMe finds missed follow-ups hiding in your inbox.');
  return {
    x: `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
    email: `mailto:?subject=${encodeURIComponent('Try NudgeForMe')}&body=${encodedText}%0A%0A${encodedUrl}`,
  };
}
